<template>
  <div class="customers">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.customer_title') }}</span>
    </div>
    <div  class="search" >
      <van-search
          v-model="account"
          show-action
          :label="$t('append_field.userName')"
          :placeholder="$t('append_field.enter_userName')"
          @search="onSearch">
        <template #action>
          <van-icon name="search"   @click="onSearch"/>
        </template>
      </van-search>
    </div>
    <div class="content" v-if="clients.userId">
      <van-form v-if="showSubmit">
        <van-field
            clearable
            v-model="clients.userName"
            :placeholder="$t('append_field.enter_userName')"
            :rules="[{ required: true}]">
          <template #label>
            <span class="required">*</span> {{ $t('append_field.userName') }}
          </template>
        </van-field>
        <van-field
            :label="$t('append_field.email')"
            clearable
            v-model="clients.email"
            :rules="[{ required: true }]">
          <template #label>
            <span class="required">*</span> {{ $t('append_field.enter_email') }}
          </template>
        </van-field>
        <van-field
            clearable
            v-model="clients.phone"
            type="number"
            :placeholder="$t('append_field.enter_phone_number')"
        />
        <van-field name="stepper"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.authorized_devices') }}
          </template>
          <template #input>
            <van-stepper input-width="120px" v-model="clients.authorizeNum" />
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="clients.name"
            :label="$t('append_field.company_name')"
            :placeholder="$t('append_field.enter_company_name')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.company_name') }}
          </template>
        </van-field>
        <van-field name="radio" :label="$t('append_field.user_status')">
          <template #input>
            <van-radio-group v-model="clients.state" direction="horizontal" v-if="clients.state!=='-2'">
              <van-radio name="1">{{ $t('append_field.enable') }}</van-radio>
              <van-radio name="-1">{{ $t('append_field.disable') }}</van-radio>
            </van-radio-group>
            <div v-else style="color: red">{{ $t('append_field.expired') }} </div>
          </template>
        </van-field>
        <van-field
            readonly
            clickable
            name="calendar"
            :value="clients.validTime"
            @click="showCalendar = true"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.valid_date')  }}
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="clients.addr"
            :label="$t('append_field.address')"
            :placeholder="$t('append_field.enter_address')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.address') }}
          </template>
        </van-field>
        <van-field
            clearable
            v-model="clients.materialRam"
            :placeholder="$t('append_field.capacity_rule')"
            :rules="[{ required: true }]"
        >
          <template #label>
            <span class="required">*</span>{{ $t('append_field.capacity_label') }}
          </template>
        </van-field>

        <div style="margin: 16px;" >
          <van-button round block type="info" native-type="submit" @click="onSubmit">{{ $t('append_field.submit_btn') }}</van-button>
        </div>
      </van-form >
      <van-cell-group v-if="!showSubmit">
        <div class="required">{{ $t('append_field.sub_accounts')}}</div>
        <!-- 用户名 -->
        <van-cell
            :title="$t('append_field.userName')"
            :value="clients.userName  || '--'"
        />
        <!-- 邮箱 -->
        <van-cell
            :title="$t('append_field.email')"
            :value="clients.email  || '--'"
        />
        <!-- 手机号 -->
        <van-cell
            :title="$t('append_field.phone_number')"
            :value="clients.phone  || '--'"
        />
        <!-- 授权设备数 -->
        <van-cell
            :title="$t('append_field.authorized_devices')"
            :value="clients.authorizeNum  || '0'"
        />
        <!-- 公司名称 -->
        <van-cell
            :title="$t('append_field.company_name')"
            :value="clients.name  || '--'"
        />
        <!-- 用户状态 -->
        <van-cell
            :title="$t('append_field.user_status')"
            :value="getStatusText(clients.state)"
        >
        </van-cell>
        <!-- 有效期 -->
        <van-cell
            :title="$t('append_field.valid_date')"
            :value="clients.validTime  || '--'"
        />
        <!-- 地址 -->
        <van-cell
            :title="$t('append_field.address')"
            :value="clients.addr  || '--'"
        />
        <!-- 存储容量 -->
        <van-cell
            :title="$t('append_field.capacity_label')"
            :value="clients.materialRam  || '--'"
        />

      </van-cell-group>
      <van-popup v-model="showCalendar" position="bottom">
        <van-datetime-picker
            type="date"
            :title="$t('append_field.selectStartDate')"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirm"
            @cancel="showCalendar = false"
        />
      </van-popup>
    </div>
    <van-empty
        v-else
        class="custom-image"
        image="/static/images/terminal/empty-img.png"
        :description="$t('append_field.data_empty')"
    />

  </div>
</template>

<script>


import {Toast} from "vant";

import CryptoJS from "crypto-js";
import qs from "qs";

function encrypt (data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
export default {

  data() {
    return {
      account:'',
      showCalendar:false,
      minDate: new Date(),
      maxDate:new Date(2999, 1, 31),
      speedLimit:'',
      clients: {},
      showSubmit:true
    }
  },
  mounted() {



  },
  methods: {
    onSearch(){
      this.clients={}
      if(this.account == ''){
        Toast(this.$t('append_field.enter_userName'))
        return
      }
      if( this.account == this.$route.query.account){
        this.showSubmit = false
      }else {
        this.showSubmit = true
      }
      this.$ajax.get(`/etv/searchCustomers.json?account=${this.account}`).then(res => {
        if (res.data.code == 0) {
          Toast(res.data.msg)
          let data=res.data.data
          this.clients  = {
            addr: data.addr,
            authorizeNum: data.authorizeNum,
            email: data.email,
            level: data.level,
            materialRam: data.materialRam,
            name: data.name,  // 姓名公司名称
            phone: data.phone,
            userId: data.psId,
            speedLimit: data.speedLimit,
            state: data.state,
            userName: data.userName,
            validTime: data.validTime
          };
          this.speedLimit  = data.speedLimit;
        } else {
          Toast(res.data.msg)
        }
      })

    },
    back() {
      this.$router.back()
    },
    onSubmit(){
      this.$ajax.post('/etv/updatePersonerById.json',qs.stringify({
        userInfo: encrypt(JSON.stringify(this.clients))
      })).then(res => {
        if (res.data.code == 0) {
          Toast(this.$t('append_field.save_success'))
        } else {
          Toast(res.data.msg)
        }
      })
    },
    // 日期和时间相关方法
    formatter(date) {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    },
    onConfirm(data) {
      this.clients.validTime = this.formatter(data)
      this.showCalendar = false

    },
    getStatusText(state) {
      const map = {
        "1": this.$t('append_field.enable'),
        "-1": this.$t('append_field.disable'),
        "-2": this.$t('append_field.expired'),
      };
      return map[state] || "--";
    },
  },


}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.customers {
  height: 100% !important;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .van-search__label{
    font-size: 16px;
  }
  .search{

  }
  .content{
    height:calc(100% - 63px - 54px);
    overflow: auto;
    .van-cell{
      display: flex;
      flex-direction: column
    }
    .van-field__label{
      width: auto;
    }

    .required{
      color: #ff0000;
      text-align: center;
    }
  }
  .custom-image{
    height:calc(100% - 63px - 54px);
    overflow: hidden;
  }
}

</style>
